;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('HeaderFilterController', HeaderFilterController)

  /* @ngInject */
  function HeaderFilterController ($scope, $timeout, HeaderFilterService) {
    $scope.taxonomyTabs = []
    $scope.activatedTab = {}
    $scope.form = {
      minDate: undefined,
      maxDate: undefined,
      tags: [],
      metadata: {}
    }

    const api = {
      _buildOptions
    }
    this.getApi = () => api

    activate()

    function activate () {}

    $scope.onChangeModel = function () {
      api._buildOptions()
    }

    $scope.reset = function () {
      $scope.form = {}
      $timeout(() => {
        $('.header-filter .input-tags-dropdown').dropdown('clear')
        $('.header-filter .input-dropdown').dropdown('clear')
      }, 100, false)
    }

    $scope.handleTaxonomyTabClick = function (tab) {
      $scope.activatedTab = tab
    }

    function _buildOptions () {
      const minDate = $scope.form.minDate
      const maxDate = $scope.form.maxDate
      const tags = $scope.form.tags || []
      const metadata = $scope.form.metadata
      const metadataFields = []

      for (const key in metadata) {
        const value = metadata[key]

        if (!value) {
          continue
        }
        $scope.taxonomyTabs.forEach(tab => {
          const field = tab.fields.find(field => field.name === key)
          if (field) {
            const option = field.options.find(option => option.value === value)
            if (option) {
              metadataFields.push({
                key: key,
                value: option.label,
                type: field.type
              })
            } else {
              metadataFields.push({
                key: key,
                value: value,
                type: field.type
              })
            }
          }
        })
      }
      let filterOptions

      if (minDate || maxDate || tags.length || metadataFields.length) {
        filterOptions = {
          minDate: minDate,
          maxDate: maxDate,
          tags: tags,
          metadataFields: metadataFields
        }
      }
      HeaderFilterService.setValue(filterOptions)
    }
  }
})()
